import { useMemo } from 'react';

import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { getVisibleCommentThreads } from '@confluence/comments-panel-utils/entry-points/getVisibleCommentThreads.ts';
import {
	LocationValue,
	getOpenCommentThreads,
	getAnnotationThreadKeys,
} from '@confluence/comments-panel-utils/entry-points/commentsPanelHelper.ts';
import { fg } from '@confluence/feature-gating';
import { useCommentsDataState } from '@confluence/comments-data/entry-points/useCommentsData.ts';
import { useProcessedCommentsDataState } from '@confluence/comments-data-manager/entry-points/useProcessedCommentsData.ts';
import { expVal } from '@confluence/feature-experiments';

export const useFooterComments = () => {
	const {
		orderedActiveAnnotationIdList,
		commentsDataMap: legacyCommentsDataMap,
		removedThreadsMap,
	} = useCommentsDataState();

	const pageMode = useGetPageMode();

	// Get processed comments data for new comments data manager
	const processedCommentsData = useProcessedCommentsDataState();

	const commentsDataMap = expVal('cc_comments_new_comments_data_manager', 'isEnabled', false)
		? processedCommentsData.commentsDataMap
		: legacyCommentsDataMap;

	return useMemo(() => {
		const footerCommentThreads = fg('confluence_frontend_content_wrapper')
			? getVisibleCommentThreads({
					includeGeneralComments: true,
					commentsDataMap,
					includeInlineComments: false,
					orderedAnnotationIds: getAnnotationThreadKeys(orderedActiveAnnotationIdList),
					pageMode,
				})
			: getOpenCommentThreads({
					commentsDataMap,
					showInlineComments: false,
					showGeneralComments: true,
					location: LocationValue.FOOTER,
					orderedActiveAnnotationIdList,
					removedThreadsMap,
				});

		const footerCommentIds = footerCommentThreads.map((thread) => thread.id);

		return {
			footerCommentIds,
			footerCommentThreads,
		};
	}, [commentsDataMap, orderedActiveAnnotationIdList, pageMode, removedThreadsMap]);
};
